var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"software"},[_c('div',{staticClass:"software-tree"},[_c('treeBox',{on:{"saved":_vm.treeData}})],1),_c('div',{staticClass:"software-con"},[_c('softList',{attrs:{"bigTypeId":_vm.treeId}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }